import { IconCircleCheck } from '@tabler/icons-react';
import classes from './style.module.css';

const FormSuccess = () => (
  <div className={classes.success}>
    <span className={classes.icon}>
      <IconCircleCheck size={54} stroke={1.6} />
    </span>
    <h2 className={classes.title}>הטופס נשלח בהצלחה!</h2>
    <p className={classes.message}>
      תודה שפניתם אלינו. צוות CreditPro קיבל את פרטיכם ויחזור אליכם בהקדם
      עם תוצאות הבדיקה הראשונית.
    </p>
  </div>
);

export default FormSuccess;
